import emoji1 from "../assets/emojis/ee_1@2x.png";
import emoji2 from "../assets/emojis/ee_2@2x.png";
import emoji3 from "../assets/emojis/ee_3@2x.png";
import emoji4 from "../assets/emojis/ee_4@2x.png";
import emoji5 from "../assets/emojis/ee_5@2x.png";
import emoji6 from "../assets/emojis/ee_6@2x.png";
import emoji7 from "../assets/emojis/ee_7@2x.png";
import emoji8 from "../assets/emojis/ee_8@2x.png";
import emoji9 from "../assets/emojis/ee_9@2x.png";
import emoji10 from "../assets/emojis/ee_10@2x.png";
import emoji11 from "../assets/emojis/ee_11@2x.png";
import emoji12 from "../assets/emojis/ee_12@2x.png";
import emoji13 from "../assets/emojis/ee_13@2x.png";
import emoji14 from "../assets/emojis/ee_14@2x.png";
import emoji15 from "../assets/emojis/ee_15@2x.png";
import emoji16 from "../assets/emojis/ee_16@2x.png";
import emoji17 from "../assets/emojis/ee_17@2x.png";
import emoji18 from "../assets/emojis/ee_18@2x.png";
import emoji19 from "../assets/emojis/ee_19@2x.png";
import emoji20 from "../assets/emojis/ee_20@2x.png";
import emoji21 from "../assets/emojis/ee_21@2x.png";
import emoji22 from "../assets/emojis/ee_22@2x.png";
import emoji23 from "../assets/emojis/ee_23@2x.png";
import emoji24 from "../assets/emojis/ee_24@2x.png";
import emoji25 from "../assets/emojis/ee_25@2x.png";
import emoji26 from "../assets/emojis/ee_26@2x.png";
import emoji27 from "../assets/emojis/ee_27@2x.png";
import emoji28 from "../assets/emojis/ee_28@2x.png";
import emoji29 from "../assets/emojis/ee_29@2x.png";
import emoji30 from "../assets/emojis/ee_30@2x.png";
import emoji31 from "../assets/emojis/ee_31@2x.png";
import emoji32 from "../assets/emojis/ee_32@2x.png";
import emoji33 from "../assets/emojis/ee_33@2x.png";
import emoji34 from "../assets/emojis/ee_34@2x.png";
import emoji35 from "../assets/emojis/ee_35@2x.png";
import emoji36 from "../assets/emojis/ee_36@2x.png";
import emoji37 from "../assets/emojis/ee_37@2x.png";
import emoji38 from "../assets/emojis/ee_38@2x.png";
import emoji39 from "../assets/emojis/ee_39@2x.png";
import emoji40 from "../assets/emojis/ee_40@2x.png";
import emoji41 from "../assets/emojis/ee_41@2x.png";
import emoji42 from "../assets/emojis/ee_42@2x.png";
import emoji43 from "../assets/emojis/ee_43@2x.png";
import emoji44 from "../assets/emojis/ee_44@2x.png";
import emoji45 from "../assets/emojis/ee_45@2x.png";
import emoji46 from "../assets/emojis/ee_46@2x.png";
import emoji47 from "../assets/emojis/ee_47@2x.png";

const emojiConfig = {
  name: "circle",
  emojis: [
    {
      id: "[):]",
      src: emoji1
    },
    {
      id: "[:D]",
      src: emoji2
    },
    {
      id: "[;)]",
      src: emoji3
    },
    {
      id: "[:-o]",
      src: emoji4
    },
    {
      id: "[:p]",
      src: emoji5
    },
    {
      id: "[(H)]",
      src: emoji6
    },
    {
      id: "[:@]",
      src: emoji7
    },
    {
      id: "[:s]",
      src: emoji8
    },
    {
      id: "[:$]",
      src: emoji9
    },
    {
      id: "[:(]",
      src: emoji10
    },
    {
      id: "[:'(]",
      src: emoji11
    },
    {
      id: "[:|]",
      src: emoji12
    },
    {
      id: "[(a)]",
      src: emoji13
    },
    {
      id: "[8o|]",
      src: emoji14
    },
    {
      id: "[8-|]",
      src: emoji15
    },
    {
      id: "[+o(]",
      src: emoji16
    },
    {
      id: "[<o)]",
      src: emoji17
    },
    {
      id: "[(U)]",
      src: emoji18
    },
    {
      id: "[|-)]",
      src: emoji19
    },
    {
      id: "[*-)]",
      src: emoji20
    },
    {
      id: "[:-#]",
      src: emoji21
    },
    {
      id: "[:-*]",
      src: emoji22
    },
    {
      id: "[^o)]",
      src: emoji23
    },
    {
      id: "[8-)]",
      src: emoji24
    },
    {
      id: "[(|)]",
      src: emoji25
    },
    {
      id: "[(u)]",
      src: emoji26
    },
    {
      id: "[(S)]",
      src: emoji27
    },
    {
      id: "[(*)]",
      src: emoji28
    },
    {
      id: "[(#)]",
      src: emoji29
    },
    {
      id: "[(R)]",
      src: emoji30
    },
    {
      id: "[({)]",
      src: emoji31
    },
    {
      id: "[(})]",
      src: emoji32
    },
    {
      id: "[(k)]",
      src: emoji33
    },
    {
      id: "[(F)]",
      src: emoji34
    },
    {
      id: "[(Z)]",
      src: emoji35
    },
    {
      id: "[(W)]",
      src: emoji36
    },
    {
      id: "[(D)]",
      src: emoji37
    },
    {
      id: "[(E)]",
      src: emoji38
    },
    {
      id: "[(T)]",
      src: emoji39
    },
    {
      id: "[(G)]",
      src: emoji40
    },
    {
      id: "[(Y)]",
      src: emoji41
    },
    {
      id: "[(I)]",
      src: emoji42
    },
    {
      id: "[(K)]",
      src: emoji43
    },
    {
      id: "[(L)]",
      src: emoji44
    },
    {
      id: "[(M)]",
      src: emoji45
    },
    {
      id: "[(N)]",
      src: emoji46
    },
    {
      id: "[(O)]",
      src: emoji47
    }
  ]
};
const emojiMap = new Map();

emojiConfig.emojis.forEach((item) => {
  emojiMap.set(item.id, item.src);
});

export { emojiConfig, emojiMap };